import React from 'react'

const RatingContainer = ({review}) => {
  return (
    <div>
    <span class="fa fa-star checked"></span>
    <span class="fa fa-star checked"></span>
    <span class="fa fa-star checked"></span>
    <span class="fa fa-star checked"></span>
    <span class="fa fa-star"></span> { review?(review):""}
</div>
  )
}

export default RatingContainer